export interface AnalysisContext {
	brandId: string;
	reading: string;
	filters: Record<string, string>;
	capturedAt: string;
}

// Session-only and brand-scoped: another brand's filters are never inherited.
export function rememberAnalysisContext(context: AnalysisContext): void {
	try {
		sessionStorage.setItem(`ondit.analysisContext.${context.brandId}`, JSON.stringify(context));
	} catch {}
}

export function readAnalysisContext(brandId: string): AnalysisContext | undefined {
	try {
		const value = JSON.parse(sessionStorage.getItem(`ondit.analysisContext.${brandId}`) ?? "null");
		if (value?.brandId === brandId && Date.now() - Date.parse(value.capturedAt) < 3_600_000) return value;
	} catch {}
	return undefined;
}
